export enum CancellationProtectionStatus {
    /** Cancellation protection exists and can be claimed by the traveller. */
    ACTIVE = "active",
    /** A cancellation protection claim has been submitted by the traveller and is under process. */
    CLAIM_SUBMITTED = "claim_submitted",
    /** The traveller has been refunded under cancellation protection. */
    CLAIM_PROCESSED = "claim_processed",
    /** The refund failed enough times that retrying will not help. Escalated to support. */
    REFUND_FAILED = "refund_failed",
    /** The claim is held back from automatic payout pending a manual look. */
    CLAIM_UNDER_REVIEW = "claim_under_review",
    /** The claim needs a refund issued by hand. */
    NEEDS_MANUAL_REFUND = "needs_manual_refund",
    /** The booking was cancelled without needing protection. */
    UNUSED = "unused",
}

export interface CancellationProtection {
    optIn?: boolean;
    /**
     * Stays `active` past `expiresAt`; it only changes once a claim exists or the protection is settled.
     */
    status?: string;
    /** Claim deadline, UTC. Moves earlier when a trip is rescheduled, so it is never derived client-side. */
    expiresAt?: string;
    fee?: number;
    /** Ceiling on the maximum refund amount, frozen at purchase. The payout is `min(item.amount, maxAmount)`. */
    maxAmount?: number;
    /** Internal product classification. Never rendered to the traveler. */
    vertical?: string;
    claimReason?: string;
    claimSubmittedAt?: string;
    claimRejectedAt?: string;
    /** When the held claim is processed for refund — roughly 48 hours after it was submitted. */
    processRefundAt?: string;
    resolution?: string;
    originTransaction?: string;
    /** Running total paid out against this protection. */
    amountRefunded?: number;
    sellerRefundAmount?: number;
    sellerRefundIssued?: boolean;
}
